import React, { useState } from 'react';
import './CustomTooltip.css'; // Import your custom CSS

const CustomTooltip = ({ content, children }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  return (

   
        <div className="custom-tooltip-container" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {children}
        {showTooltip && <div className={ content?.length >= 1 ?"custom-tooltip" : ""}>{content?.map((item, index) => {return <p key={index}>{item}</p>})}</div>}
      </div>
  
    
 
  );
};

export default CustomTooltip;
